import { rect, aRect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Part } from '../../types';

export const cockpits: Record<string, Part> = {
  cockpit_bubble: {
    id: 'cockpit_bubble',
    category: 'cockpit',
    name: 'Bubble',
    requires: SLOT.COCKPIT,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 4, 1, p.glassDark); aRect(ctx, a.x, a.y + 1, 4, 2, p.glass); aRect(ctx, a.x, a.y + 1, 2, 1, p.light); },
  },
  cockpit_canopy: {
    id: 'cockpit_canopy',
    category: 'cockpit',
    name: 'Canopy',
    requires: SLOT.COCKPIT,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 1, 2, 1, p.glassDark); aRect(ctx, a.x, a.y, 4, 3, p.glass); aRect(ctx, a.x, a.y + 3, 4, 1, p.glassDark); aRect(ctx, a.x, a.y, 2, 1, p.light); },
  },
  cockpit_slit: {
    id: 'cockpit_slit',
    category: 'cockpit',
    name: 'Slit',
    requires: SLOT.COCKPIT,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y + 1, 6, 1, p.glassDark); aRect(ctx, a.x, a.y + 2, 6, 1, p.glass); aRect(ctx, a.x, a.y + 2, 2, 1, p.glassLight); },
  },
  cockpit_dome: {
    id: 'cockpit_dome',
    category: 'cockpit',
    name: 'Dome',
    requires: SLOT.COCKPIT,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 1, 2, 1, p.glass); aRect(ctx, a.x, a.y, 4, 3, p.glass); aRect(ctx, a.x, a.y, 2, 1, p.glassLight); aRect(ctx, a.x, a.y + 3, 2, 1, p.glassDark); },
  },
  cockpit_split: {
    id: 'cockpit_split',
    category: 'cockpit',
    name: 'Split',
    requires: SLOT.COCKPIT,
    draw: (ctx, a, p) => { rect(ctx, a.x - 3, a.y, 2, 2, p.glass); rect(ctx, a.x + 1, a.y, 2, 2, p.glass); rect(ctx, a.x - 3, a.y, 2, 1, p.glassDark); rect(ctx, a.x + 1, a.y, 2, 1, p.glassDark); aRect(ctx, a.x, a.y, 2, 2, p.metalDark); },
  },
  cockpit_visor: {
    id: 'cockpit_visor',
    category: 'cockpit',
    name: 'Visor',
    requires: SLOT.COCKPIT,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 8, 1, p.metalDark); aRect(ctx, a.x, a.y + 1, 8, 1, p.glass); aRect(ctx, a.x, a.y + 1, 2, 1, p.glassLight); aRect(ctx, a.x, a.y + 2, 8, 1, p.metalDark); },
  },
  cockpit_bridge: {
    id: 'cockpit_bridge',
    category: 'cockpit',
    name: 'Bridge',
    requires: SLOT.COCKPIT,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 6, 1, p.metalDark); aRect(ctx, a.x, a.y + 1, 6, 2, p.glass); rect(ctx, a.x - 2, a.y + 1, 1, 2, p.metalDark); rect(ctx, a.x + 1, a.y + 1, 1, 2, p.metalDark); aRect(ctx, a.x, a.y + 3, 6, 1, p.metalDark); },
  },
  cockpit_panoramic: {
    id: 'cockpit_panoramic',
    category: 'cockpit',
    name: 'Panoramic',
    requires: SLOT.COCKPIT,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 12, 1, p.metalDark); aRect(ctx, a.x, a.y + 1, 12, 1, p.glass); aRect(ctx, a.x, a.y + 1, 6, 1, p.glassLight); aRect(ctx, a.x, a.y + 2, 12, 1, p.metalDark); },
  },
  cockpit_porthole: {
    id: 'cockpit_porthole',
    category: 'cockpit',
    name: 'Porthole',
    requires: SLOT.COCKPIT,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y + 1, 4, 3, p.metalDark); aRect(ctx, a.x, a.y + 1, 2, 3, p.glass); aRect(ctx, a.x, a.y + 1, 2, 1, p.glassLight); aRect(ctx, a.x, a.y + 3, 2, 1, p.glassDark); },
  },
  cockpit_hood: {
    id: 'cockpit_hood',
    category: 'cockpit',
    name: 'Hood',
    requires: SLOT.COCKPIT,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.glassDark); aRect(ctx, a.x, a.y + 1, 4, 1, p.glassDark); aRect(ctx, a.x, a.y + 2, 6, 2, p.glass); aRect(ctx, a.x, a.y + 2, 2, 1, p.glassLight); aRect(ctx, a.x, a.y + 4, 6, 1, p.glassDark); },
  },
};
